const JobType = {
  HD_REAL: 0,
  BASIC_HDR: 1,
};

export default JobType;
